import React from 'react';
import AbstractRequestTask from './AbstractRequestTask';

class SendFriendTask extends AbstractRequestTask {

  constructor(config, user, params) {
    super();
    this.config = config;
    this.user = user;
    this.params = params;
  }

  getUrl() {
    return `https://www.clarovideo.com/${this.user.region}/vcard/tofriend`;
  }

  getParams() {
    let params = {} // super.getParams(this.config);
    this.params = Object.assign(params, this.params);

    return this.params;
  }

  success(data, b) {
    this.resolve(data);
  }

  getMethod() {
    return 'POST';
  }
}

export default SendFriendTask;
